export default "__VITE_ASSET__nIW_tqlq__"